/**************************************************************************************************/
/** @import Classes/Records                                                                      **/
/**************************************************************************************************/
import FieldsOptions from '@/Classes/Records/FieldsOptions'
import { ItemMissingFields } from '@/Classes/Records/ItemMissingFields'

/**************************************************************************************************/
/** @import Constants                                                                            **/
/**************************************************************************************************/
import { ActionFields } from '@/Constants/ActionFields'

/**************************************************************************************************/
/** @import Helpers/Components                                                                   **/
/**************************************************************************************************/
import { BuilderManager } from '@/Helpers/Components/DataTable/BuilderManager'

/**************************************************************************************************/
/** @export Function @name parseItemsResponse                                                    **/
/**************************************************************************************************/
export function parseItemsResponse(data: Array<any>)
{
	// Clase Constructora.
	const bm = new BuilderManager(data, ActionFields.Delete)

	// Aplicar opciones a los campos.
	bm.parseFieldsOptions(new FieldsOptions()
		.add('num', '#').isSortable().setAlign('center', 'center').setStyleTh({ width: '64px' })
		.add('name', 'Descripción').setEditable({ hint: 'Item descripción ...' }).isSortable().setAlign('center')
		.add('critical', 'Critico').setAlign('center', 'center').setCheckBox({ }).setStyleTh({ width: '80px' })
	)

	// Aplicar un nuevo Orden a todas las columnas visibles.
	bm.rearrangeFields('num', 'name', 'critical')

	// Aplicar un valor a los campos e items si no estan presentes.
	bm.parseItemsMissingFields(new ItemMissingFields()
		.add('num', { $text: 'AUTO_INCREMENT' })
	)

	// Definir los formatos que serán aplicados al valor de la celda.
	bm.parseItemsFormatters({
		name: (value: string) =>
		{
			return value
		}
	})

	// Retornar Objeto con los Campos, Items y Acciones.
	return bm.packWithActions()
}